import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.math.sign.js";
import { store } from '@/store';
/**
 * Determine if a generic indicator-based rule is passed.
 * @param {Object} payload
 * @param {Object} payload.enabled If the rule is enabled.
 * @param {Number} payload.indicatorId The id of the indicator
 * @param {Number} payload.scoreRequired The score required to attain to pass the rule
 * @param {Boolean} payload.lowerBound The type of bound in the comparison, defaults to true, else it's an upper bound
 * @param {Boolean} payload.strict Whether the rule is strict or not, defaults to false (<= rather than <)
 * @returns {Boolean} True if the rule is passed, else false
 */

export function passesIndicatorRule(_ref) {
  var enabled = _ref.enabled,
      indicatorId = _ref.indicatorId,
      scoreRequired = _ref.scoreRequired,
      _ref$lowerBound = _ref.lowerBound,
      lowerBound = _ref$lowerBound === void 0 ? true : _ref$lowerBound,
      _ref$strict = _ref.strict,
      strict = _ref$strict === void 0 ? false : _ref$strict;

  // If the rule configuration *has* an 'enabled' property, and it's explicitly set to false (not undefined),
  // then we're being told that the rule is disabled, so it's an automatic pass.
  if (enabled === false) {
    return true;
  } // If misconfigured, the test fails. We must avoid a false negative (0) for scoreRequired by comparing vs null, not 0.


  if (!indicatorId || scoreRequired == null) {
    return false;
  } // Get the actual score attained for the specified indicator id


  var score = store.getters['answers/getIndicatorScoreById'](indicatorId); // If no score was provided (null/undefined), we are required to fail the rule at this point.
  //   We need to be careful about falsiness here vs the crappy legacy implementation which wasn't -
  // as indicators like NPS can have a valid value of 0, and that should not cause us to return false early.
  // (The legacy version just wouldn't ban NPS as a valid indicator to use for a rule sometimes, which is awful!)

  if (score == null) {
    return false;
  } // Perform the comparison:


  return [].concat(_toConsumableArray(strict ? [] : [0]), [// Apply lowerBound
  lowerBound ? 1 : -1]).includes(Math.sign(score - scoreRequired));
}